// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-workspace-shell {
  min-height: 100vh;
  background: #e8e5dc;
}

.canvas-workspace-header {
  position: sticky;
  top: 0;
  z-index: 1200;
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  color: #f4f0e6;
  background: #11120f;
  border-bottom: 1px solid #34372f;
  box-shadow: 0 12px 30px rgba(23, 23, 18, 0.14);
}

.canvas-workspace-account {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 13px;
}

.canvas-workspace-profile {
  position: relative;
}

.canvas-workspace-login {
  min-width: 88px;
  min-height: 38px;
  padding: 8px 20px;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border: 1px solid var(--canvas-ink, #171a17);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.canvas-workspace-login:hover {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
  transform: translateY(-1px);
}

.canvas-workspace-login:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.canvas-workspace-profile-rail {
  position: fixed;
  bottom: 18px;
  left: 0;
  z-index: 1400;
  display: flex;
  width: 88px;
  justify-content: center;
  pointer-events: none;
}

.canvas-workspace-profile-rail .canvas-workspace-profile {
  pointer-events: auto;
}

.canvas-workspace-profile-trigger {
  display: grid;
  width: 48px;
  height: 48px;
  min-width: 48px;
  place-items: center;
  padding: 2px;
  color: var(--canvas-ink, #171a17);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 14px;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.canvas-workspace-profile-trigger:hover,
.canvas-workspace-profile-trigger.is-open {
  background: #f1f6ed;
  border-color: var(--canvas-line, #e2e6e4);
  box-shadow: 0 6px 18px rgba(24, 30, 26, 0.08);
}

.canvas-workspace-profile-trigger:focus-visible,
.canvas-workspace-profile-actions button:focus-visible,
.canvas-workspace-profile-tasks-header a:focus-visible,
.canvas-workspace-profile-name-row button:focus-visible,
.canvas-workspace-profile-name-controls input:focus-visible,
.canvas-workspace-profile-name-controls button:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.canvas-workspace-profile-avatar {
  display: grid;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  place-items: center;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-radius: 11px;
  font-size: 14px;
  font-weight: 700;
}

.canvas-workspace-profile-card {
  position: absolute;
  right: auto;
  bottom: calc(100% + 10px);
  left: calc(100% + 20px);
  z-index: 10;
  width: 392px;
  max-height: calc(100vh - 96px);
  overflow-x: hidden;
  overflow-y: auto;
  color: var(--canvas-ink, #171a17);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 14px;
  box-shadow: 0 18px 46px rgba(24, 30, 26, 0.15);
  animation: canvas-workspace-profile-enter 150ms ease-out;
  backdrop-filter: blur(18px);
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

@keyframes canvas-workspace-profile-enter {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Keep the profile trigger itself usable when the rail is compressed. */
@media (max-width: 768px) {
  .canvas-workspace-profile-rail {
    bottom: 16px;
    width: 76px;
  }
}

@media (max-width: 720px) {
  .canvas-workspace-profile-rail {
    bottom: 12px;
    width: 68px;
  }

  .canvas-workspace-profile-trigger {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  .canvas-workspace-profile-avatar {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }

  .canvas-workspace-profile-card {
    position: fixed;
    right: 10px;
    bottom: 68px;
    left: 10px;
    width: auto;
    max-height: calc(100vh - 84px);
  }
}

.canvas-workspace-profile-card-header {
  display: flex;
  flex-direction: column;
  padding: 19px 19px 15px;
}

.canvas-workspace-profile-card-eyebrow {
  margin-bottom: 7px;
  color: var(--canvas-green-strong, #70a33d);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.canvas-workspace-profile-card-header strong {
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas-workspace-profile-name-row {
  display: flex;
  min-height: 26px;
  align-items: center;
  gap: 9px;
}

.canvas-workspace-profile-name-row > strong {
  min-width: 0;
}

.canvas-workspace-profile-name-row > button {
  display: inline-flex;
  min-height: 26px;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  color: #4f6146;
  background: var(--canvas-green-soft, #e3f3cb);
  border: 1px solid var(--canvas-green, #b9df8a);
  border-radius: 7px;
  font-size: 10px;
  font-weight: 700;
  transition: background 150ms ease, border-color 150ms ease, transform 150ms ease;
}

.canvas-workspace-profile-name-row > button:hover {
  background: #edf8df;
  border-color: var(--canvas-green-strong, #70a33d);
  transform: translateY(-1px);
}

.canvas-workspace-profile-name-row > button svg {
  width: 11px;
  height: 11px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.35;
}

.canvas-workspace-profile-name-form {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.canvas-workspace-profile-name-form > label {
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
  font-weight: 650;
}

.canvas-workspace-profile-name-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 6px;
}

.canvas-workspace-profile-name-controls input {
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  color: var(--canvas-ink, #171a17);
  background: #fff;
  border: 1px solid var(--canvas-line-strong, #ccd2ce);
  border-radius: 8px;
  font-size: 13px;
}

.canvas-workspace-profile-name-controls input[aria-invalid='true'] {
  border-color: #c96b62;
}

.canvas-workspace-profile-name-controls button {
  min-width: 48px;
  height: 34px;
  padding: 0 9px;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border: 1px solid var(--canvas-ink, #171a17);
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
}

.canvas-workspace-profile-name-controls button:last-child {
  color: #59615a;
  background: #fff;
  border-color: var(--canvas-line, #e2e6e4);
}

.canvas-workspace-profile-name-controls button:hover:not(:disabled) {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
}

.canvas-workspace-profile-name-controls button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.canvas-workspace-profile-name-message {
  color: var(--canvas-muted, #737b75);
  font-size: 9px;
  line-height: 1.35;
}

.canvas-workspace-profile-name-message.is-error {
  color: #a9463f;
}

.canvas-workspace-profile-name-message.is-success {
  color: #4f7b2f;
  font-weight: 650;
}

.canvas-workspace-profile-details {
  display: grid;
  grid-template-columns: 1.35fr 1fr;
  gap: 8px;
  padding: 0 12px 12px;
}

.canvas-workspace-profile-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
  padding: 12px;
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 10px;
}

.canvas-workspace-profile-detail span {
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.canvas-workspace-profile-detail strong {
  overflow: hidden;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 13px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas-workspace-profile-points {
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
}

.canvas-workspace-profile-points strong {
  font-size: 15px;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.025em;
}

.canvas-workspace-profile-points-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.canvas-workspace-profile-points-heading > a {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 3px;
  padding: 3px 7px;
  color: #365c1d;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(112, 163, 61, 0.28);
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.2;
  text-decoration: none;
  transition: background 150ms ease, border-color 150ms ease, transform 150ms ease;
}

.canvas-workspace-profile-points-heading > a:hover {
  color: #294a15;
  background: #fff;
  border-color: rgba(112, 163, 61, 0.5);
  transform: translateY(-1px);
}

.canvas-workspace-profile-points-heading > a:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.canvas-workspace-profile-tasks {
  padding: 14px 12px 12px;
  border-top: 1px solid var(--canvas-line, #e2e6e4);
}

.canvas-workspace-profile-tasks-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 0 3px;
}

.canvas-workspace-profile-tasks-header > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.canvas-workspace-profile-tasks-header > div > span {
  color: var(--canvas-muted, #737b75);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.canvas-workspace-profile-tasks-header strong {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
}

.canvas-workspace-profile-tasks-header strong small {
  display: inline-flex;
  min-width: 22px;
  height: 17px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  color: #587139;
  background: var(--canvas-green-soft, #e3f3cb);
  border-radius: 999px;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
  font-weight: 700;
}

.canvas-workspace-profile-tasks-header a {
  flex: 0 0 auto;
  padding: 4px 0;
  color: var(--canvas-green-strong, #70a33d);
  font-size: 10px;
  font-weight: 650;
  text-decoration: none;
}

.canvas-workspace-profile-tasks-header a:hover {
  color: #426d22;
}

.canvas-workspace-profile-task-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 10px;
}

.canvas-workspace-profile-task {
  display: grid;
  min-width: 0;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 10px;
  padding: 7px;
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 10px;
}

.canvas-workspace-profile-task-media {
  position: relative;
  display: grid;
  width: 58px;
  height: 48px;
  place-items: center;
  overflow: hidden;
  color: #8d968f;
  background: #e9eeeb;
  border-radius: 7px;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.canvas-workspace-profile-task-media img,
.canvas-workspace-profile-task-media video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.canvas-workspace-profile-task-body {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  gap: 9px;
}

.canvas-workspace-profile-task-topline,
.canvas-workspace-profile-task-meta {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.canvas-workspace-profile-task-topline > strong {
  min-width: 0;
  overflow: hidden;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas-workspace-profile-task-status {
  display: inline-flex;
  height: 19px;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  padding: 0 7px;
  color: #5d694f;
  background: #edf0ed;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 650;
}

.canvas-workspace-profile-task-status i {
  width: 5px;
  height: 5px;
  background: currentColor;
  border-radius: 50%;
}

.canvas-workspace-profile-task-status.is-completed {
  color: #4f802e;
  background: #e4f3d6;
}

.canvas-workspace-profile-task-status.is-processing {
  color: #9b6b21;
  background: #f8efd9;
}

.canvas-workspace-profile-task-status.is-failed {
  color: #b64d49;
  background: #fae7e5;
}

.canvas-workspace-profile-task-meta {
  color: var(--canvas-muted, #737b75);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
}

.canvas-workspace-profile-task-meta span {
  color: var(--canvas-green-strong, #70a33d);
  font-weight: 700;
}

.canvas-workspace-profile-task-empty {
  display: grid;
  min-height: 62px;
  place-items: center;
  color: var(--canvas-muted, #737b75);
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px dashed var(--canvas-line-strong, #ccd2ce);
  border-radius: 10px;
  font-size: 10px;
}

.canvas-workspace-profile-task-skeleton {
  display: grid;
  grid-template-columns: 58px 1fr;
  gap: 10px;
  padding: 7px;
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 10px;
}

.canvas-workspace-profile-task-skeleton > i,
.canvas-workspace-profile-task-skeleton b {
  display: block;
  background: linear-gradient(90deg, #e8ece9 25%, #f5f7f5 45%, #e8ece9 65%);
  background-size: 220% 100%;
  animation: canvas-workspace-task-shimmer 1.2s linear infinite;
}

.canvas-workspace-profile-task-skeleton > i {
  width: 58px;
  height: 48px;
  border-radius: 7px;
}

.canvas-workspace-profile-task-skeleton > span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.canvas-workspace-profile-task-skeleton b {
  width: 75%;
  height: 8px;
  border-radius: 999px;
}

.canvas-workspace-profile-task-skeleton b:last-child {
  width: 52%;
}

@keyframes canvas-workspace-task-shimmer {
  to { background-position: -220% 0; }
}

.canvas-workspace-profile-actions {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--canvas-line, #e2e6e4);
}

.canvas-workspace-profile-actions button {
  min-height: 34px;
  flex: 1;
  padding: 7px 10px;
  color: #59615a;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 8px;
  font-size: 11px;
  transition: background 150ms ease, border-color 150ms ease;
}

.canvas-workspace-profile-actions .canvas-workspace-profile-admin-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #c8df9a;
  border-radius: 10px;
  background: #eff8dc;
  color: #2d4319;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.canvas-workspace-profile-actions .canvas-workspace-profile-admin-link:hover {
  border-color: #9fc35e;
  background: #e4f2c7;
}

.canvas-workspace-profile-actions button:hover:not(:disabled) {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-surface-soft, #f7f8f8);
  border-color: var(--canvas-line-strong, #ccd2ce);
}

.canvas-workspace-profile-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.canvas-workspace-profile-actions .canvas-workspace-profile-logout {
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-color: var(--canvas-ink, #171a17);
}

.canvas-workspace-profile-actions .canvas-workspace-profile-logout:hover:not(:disabled) {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
}

.canvas-workspace-content {
  min-height: calc(100vh - 72px);
}

@media (max-width: 720px) {
  .canvas-workspace-header { padding: 0 16px; }
}

@media (prefers-reduced-motion: reduce) {
  .canvas-workspace-profile-card { animation: none; }
  .canvas-workspace-profile-task-skeleton > i,
  .canvas-workspace-profile-task-skeleton b { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkspaceLayout/WorkspaceLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kGAAkG;AACpG;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;;EAEE,mBAAmB;EACnB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;;;;;;EAME,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;EACrC,6CAA6C;EAC7C,mBAAmB;EACnB,8CAA8C;EAC9C,wDAAwD;EACxD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kDAAkD;EAClD,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,+CAA+C;EAC/C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,6CAA6C;EAC7C,oBAAoB;EACpB,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,SAAS;EACT,YAAY;EACZ,+CAA+C;EAC/C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,+CAA+C;EAC/C,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,YAAY;EACZ,+CAA+C;EAC/C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B,eAAe,EAAE;AAC9C;;AAEA;EACE,iCAAiC,eAAe,EAAE;EAClD;8CAC4C,eAAe,EAAE;AAC/D","sourcesContent":[".canvas-workspace-shell {\n  min-height: 100vh;\n  background: #e8e5dc;\n}\n\n.canvas-workspace-header {\n  position: sticky;\n  top: 0;\n  z-index: 1200;\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 30px;\n  color: #f4f0e6;\n  background: #11120f;\n  border-bottom: 1px solid #34372f;\n  box-shadow: 0 12px 30px rgba(23, 23, 18, 0.14);\n}\n\n.canvas-workspace-account {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  font-size: 13px;\n}\n\n.canvas-workspace-profile {\n  position: relative;\n}\n\n.canvas-workspace-login {\n  min-width: 88px;\n  min-height: 38px;\n  padding: 8px 20px;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border: 1px solid var(--canvas-ink, #171a17);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.canvas-workspace-login:hover {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n  transform: translateY(-1px);\n}\n\n.canvas-workspace-login:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.canvas-workspace-profile-rail {\n  position: fixed;\n  bottom: 18px;\n  left: 0;\n  z-index: 1400;\n  display: flex;\n  width: 88px;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.canvas-workspace-profile-rail .canvas-workspace-profile {\n  pointer-events: auto;\n}\n\n.canvas-workspace-profile-trigger {\n  display: grid;\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  place-items: center;\n  padding: 2px;\n  color: var(--canvas-ink, #171a17);\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 14px;\n  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n\n.canvas-workspace-profile-trigger:hover,\n.canvas-workspace-profile-trigger.is-open {\n  background: #f1f6ed;\n  border-color: var(--canvas-line, #e2e6e4);\n  box-shadow: 0 6px 18px rgba(24, 30, 26, 0.08);\n}\n\n.canvas-workspace-profile-trigger:focus-visible,\n.canvas-workspace-profile-actions button:focus-visible,\n.canvas-workspace-profile-tasks-header a:focus-visible,\n.canvas-workspace-profile-name-row button:focus-visible,\n.canvas-workspace-profile-name-controls input:focus-visible,\n.canvas-workspace-profile-name-controls button:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.canvas-workspace-profile-avatar {\n  display: grid;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 11px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.canvas-workspace-profile-card {\n  position: absolute;\n  right: auto;\n  bottom: calc(100% + 10px);\n  left: calc(100% + 20px);\n  z-index: 10;\n  width: 392px;\n  max-height: calc(100vh - 96px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  color: var(--canvas-ink, #171a17);\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 14px;\n  box-shadow: 0 18px 46px rgba(24, 30, 26, 0.15);\n  animation: canvas-workspace-profile-enter 150ms ease-out;\n  backdrop-filter: blur(18px);\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n}\n\n@keyframes canvas-workspace-profile-enter {\n  from {\n    opacity: 0;\n    transform: translateY(-4px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Keep the profile trigger itself usable when the rail is compressed. */\n@media (max-width: 768px) {\n  .canvas-workspace-profile-rail {\n    bottom: 16px;\n    width: 76px;\n  }\n}\n\n@media (max-width: 720px) {\n  .canvas-workspace-profile-rail {\n    bottom: 12px;\n    width: 68px;\n  }\n\n  .canvas-workspace-profile-trigger {\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n  }\n\n  .canvas-workspace-profile-avatar {\n    width: 38px;\n    height: 38px;\n    flex-basis: 38px;\n  }\n\n  .canvas-workspace-profile-card {\n    position: fixed;\n    right: 10px;\n    bottom: 68px;\n    left: 10px;\n    width: auto;\n    max-height: calc(100vh - 84px);\n  }\n}\n\n.canvas-workspace-profile-card-header {\n  display: flex;\n  flex-direction: column;\n  padding: 19px 19px 15px;\n}\n\n.canvas-workspace-profile-card-eyebrow {\n  margin-bottom: 7px;\n  color: var(--canvas-green-strong, #70a33d);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n}\n\n.canvas-workspace-profile-card-header strong {\n  overflow: hidden;\n  font-size: 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.canvas-workspace-profile-name-row {\n  display: flex;\n  min-height: 26px;\n  align-items: center;\n  gap: 9px;\n}\n\n.canvas-workspace-profile-name-row > strong {\n  min-width: 0;\n}\n\n.canvas-workspace-profile-name-row > button {\n  display: inline-flex;\n  min-height: 26px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  color: #4f6146;\n  background: var(--canvas-green-soft, #e3f3cb);\n  border: 1px solid var(--canvas-green, #b9df8a);\n  border-radius: 7px;\n  font-size: 10px;\n  font-weight: 700;\n  transition: background 150ms ease, border-color 150ms ease, transform 150ms ease;\n}\n\n.canvas-workspace-profile-name-row > button:hover {\n  background: #edf8df;\n  border-color: var(--canvas-green-strong, #70a33d);\n  transform: translateY(-1px);\n}\n\n.canvas-workspace-profile-name-row > button svg {\n  width: 11px;\n  height: 11px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.35;\n}\n\n.canvas-workspace-profile-name-form {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.canvas-workspace-profile-name-form > label {\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n  font-weight: 650;\n}\n\n.canvas-workspace-profile-name-controls {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  gap: 6px;\n}\n\n.canvas-workspace-profile-name-controls input {\n  min-width: 0;\n  height: 34px;\n  padding: 0 10px;\n  color: var(--canvas-ink, #171a17);\n  background: #fff;\n  border: 1px solid var(--canvas-line-strong, #ccd2ce);\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.canvas-workspace-profile-name-controls input[aria-invalid='true'] {\n  border-color: #c96b62;\n}\n\n.canvas-workspace-profile-name-controls button {\n  min-width: 48px;\n  height: 34px;\n  padding: 0 9px;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border: 1px solid var(--canvas-ink, #171a17);\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.canvas-workspace-profile-name-controls button:last-child {\n  color: #59615a;\n  background: #fff;\n  border-color: var(--canvas-line, #e2e6e4);\n}\n\n.canvas-workspace-profile-name-controls button:hover:not(:disabled) {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n}\n\n.canvas-workspace-profile-name-controls button:disabled {\n  cursor: wait;\n  opacity: 0.55;\n}\n\n.canvas-workspace-profile-name-message {\n  color: var(--canvas-muted, #737b75);\n  font-size: 9px;\n  line-height: 1.35;\n}\n\n.canvas-workspace-profile-name-message.is-error {\n  color: #a9463f;\n}\n\n.canvas-workspace-profile-name-message.is-success {\n  color: #4f7b2f;\n  font-weight: 650;\n}\n\n.canvas-workspace-profile-details {\n  display: grid;\n  grid-template-columns: 1.35fr 1fr;\n  gap: 8px;\n  padding: 0 12px 12px;\n}\n\n.canvas-workspace-profile-detail {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 7px;\n  padding: 12px;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 10px;\n}\n\n.canvas-workspace-profile-detail span {\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.canvas-workspace-profile-detail strong {\n  overflow: hidden;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 13px;\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.canvas-workspace-profile-points {\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n}\n\n.canvas-workspace-profile-points strong {\n  font-size: 15px;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.025em;\n}\n\n.canvas-workspace-profile-points-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.canvas-workspace-profile-points-heading > a {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 3px;\n  padding: 3px 7px;\n  color: #365c1d;\n  background: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(112, 163, 61, 0.28);\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-decoration: none;\n  transition: background 150ms ease, border-color 150ms ease, transform 150ms ease;\n}\n\n.canvas-workspace-profile-points-heading > a:hover {\n  color: #294a15;\n  background: #fff;\n  border-color: rgba(112, 163, 61, 0.5);\n  transform: translateY(-1px);\n}\n\n.canvas-workspace-profile-points-heading > a:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.canvas-workspace-profile-tasks {\n  padding: 14px 12px 12px;\n  border-top: 1px solid var(--canvas-line, #e2e6e4);\n}\n\n.canvas-workspace-profile-tasks-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 0 3px;\n}\n\n.canvas-workspace-profile-tasks-header > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.canvas-workspace-profile-tasks-header > div > span {\n  color: var(--canvas-muted, #737b75);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n}\n\n.canvas-workspace-profile-tasks-header strong {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n}\n\n.canvas-workspace-profile-tasks-header strong small {\n  display: inline-flex;\n  min-width: 22px;\n  height: 17px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  color: #587139;\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-radius: 999px;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n  font-weight: 700;\n}\n\n.canvas-workspace-profile-tasks-header a {\n  flex: 0 0 auto;\n  padding: 4px 0;\n  color: var(--canvas-green-strong, #70a33d);\n  font-size: 10px;\n  font-weight: 650;\n  text-decoration: none;\n}\n\n.canvas-workspace-profile-tasks-header a:hover {\n  color: #426d22;\n}\n\n.canvas-workspace-profile-task-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin-top: 10px;\n}\n\n.canvas-workspace-profile-task {\n  display: grid;\n  min-width: 0;\n  grid-template-columns: 58px minmax(0, 1fr);\n  gap: 10px;\n  padding: 7px;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 10px;\n}\n\n.canvas-workspace-profile-task-media {\n  position: relative;\n  display: grid;\n  width: 58px;\n  height: 48px;\n  place-items: center;\n  overflow: hidden;\n  color: #8d968f;\n  background: #e9eeeb;\n  border-radius: 7px;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.canvas-workspace-profile-task-media img,\n.canvas-workspace-profile-task-media video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.canvas-workspace-profile-task-body {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  justify-content: center;\n  gap: 9px;\n}\n\n.canvas-workspace-profile-task-topline,\n.canvas-workspace-profile-task-meta {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.canvas-workspace-profile-task-topline > strong {\n  min-width: 0;\n  overflow: hidden;\n  font-size: 11px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.canvas-workspace-profile-task-status {\n  display: inline-flex;\n  height: 19px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 4px;\n  padding: 0 7px;\n  color: #5d694f;\n  background: #edf0ed;\n  border-radius: 999px;\n  font-size: 8px;\n  font-weight: 650;\n}\n\n.canvas-workspace-profile-task-status i {\n  width: 5px;\n  height: 5px;\n  background: currentColor;\n  border-radius: 50%;\n}\n\n.canvas-workspace-profile-task-status.is-completed {\n  color: #4f802e;\n  background: #e4f3d6;\n}\n\n.canvas-workspace-profile-task-status.is-processing {\n  color: #9b6b21;\n  background: #f8efd9;\n}\n\n.canvas-workspace-profile-task-status.is-failed {\n  color: #b64d49;\n  background: #fae7e5;\n}\n\n.canvas-workspace-profile-task-meta {\n  color: var(--canvas-muted, #737b75);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n}\n\n.canvas-workspace-profile-task-meta span {\n  color: var(--canvas-green-strong, #70a33d);\n  font-weight: 700;\n}\n\n.canvas-workspace-profile-task-empty {\n  display: grid;\n  min-height: 62px;\n  place-items: center;\n  color: var(--canvas-muted, #737b75);\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px dashed var(--canvas-line-strong, #ccd2ce);\n  border-radius: 10px;\n  font-size: 10px;\n}\n\n.canvas-workspace-profile-task-skeleton {\n  display: grid;\n  grid-template-columns: 58px 1fr;\n  gap: 10px;\n  padding: 7px;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 10px;\n}\n\n.canvas-workspace-profile-task-skeleton > i,\n.canvas-workspace-profile-task-skeleton b {\n  display: block;\n  background: linear-gradient(90deg, #e8ece9 25%, #f5f7f5 45%, #e8ece9 65%);\n  background-size: 220% 100%;\n  animation: canvas-workspace-task-shimmer 1.2s linear infinite;\n}\n\n.canvas-workspace-profile-task-skeleton > i {\n  width: 58px;\n  height: 48px;\n  border-radius: 7px;\n}\n\n.canvas-workspace-profile-task-skeleton > span {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n.canvas-workspace-profile-task-skeleton b {\n  width: 75%;\n  height: 8px;\n  border-radius: 999px;\n}\n\n.canvas-workspace-profile-task-skeleton b:last-child {\n  width: 52%;\n}\n\n@keyframes canvas-workspace-task-shimmer {\n  to { background-position: -220% 0; }\n}\n\n.canvas-workspace-profile-actions {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  border-top: 1px solid var(--canvas-line, #e2e6e4);\n}\n\n.canvas-workspace-profile-actions button {\n  min-height: 34px;\n  flex: 1;\n  padding: 7px 10px;\n  color: #59615a;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 8px;\n  font-size: 11px;\n  transition: background 150ms ease, border-color 150ms ease;\n}\n\n.canvas-workspace-profile-actions .canvas-workspace-profile-admin-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid #c8df9a;\n  border-radius: 10px;\n  background: #eff8dc;\n  color: #2d4319;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.canvas-workspace-profile-actions .canvas-workspace-profile-admin-link:hover {\n  border-color: #9fc35e;\n  background: #e4f2c7;\n}\n\n.canvas-workspace-profile-actions button:hover:not(:disabled) {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border-color: var(--canvas-line-strong, #ccd2ce);\n}\n\n.canvas-workspace-profile-actions button:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.canvas-workspace-profile-actions .canvas-workspace-profile-logout {\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-color: var(--canvas-ink, #171a17);\n}\n\n.canvas-workspace-profile-actions .canvas-workspace-profile-logout:hover:not(:disabled) {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n}\n\n.canvas-workspace-content {\n  min-height: calc(100vh - 72px);\n}\n\n@media (max-width: 720px) {\n  .canvas-workspace-header { padding: 0 16px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .canvas-workspace-profile-card { animation: none; }\n  .canvas-workspace-profile-task-skeleton > i,\n  .canvas-workspace-profile-task-skeleton b { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
